import React, { useState, useEffect, useCallback } from 'react';
import axios from '../config/axios';
import '../assets/styles/StreakTracker.css';

const StreakTracker = ({ kidUserId }) => {
  const [streakData, setStreakData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStreakStatus = useCallback(async () => {
    try {
      const response = await axios.get(`/api/v1/reports/streak-status?kid_user_id=${kidUserId}`);
      setStreakData(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch streak status:', err);
      setError('Failed to load streak data');
    } finally {
      setLoading(false);
    }
  }, [kidUserId]);

  useEffect(() => {
    fetchStreakStatus();
  }, [fetchStreakStatus]);

  if (loading) {
    return <div className="streak-tracker-loading">Loading streak...</div>;
  }

  if (error) {
    return <div className="streak-tracker-error">{error}</div>;
  }

  if (!streakData) {
    return null;
  }

  const { current_streak, next_milestone } = streakData;
  const hasStreak = current_streak > 0;
  const hasNextMilestone = next_milestone && next_milestone.days;

  return (
    <div className="streak-tracker">
      <div className="streak-main">
        <div className="streak-flame">
          {hasStreak ? '🔥' : '💤'}
        </div>
        <div className="streak-info">
          <div className="streak-count">{current_streak}</div>
          <div className="streak-label">Day Streak</div>
        </div>
      </div>

      {hasNextMilestone && (
        <div className="streak-milestone">
          <div className="milestone-header">
            <span className="milestone-icon">🎯</span>
            <span className="milestone-title">Next Milestone</span>
          </div>
          <div className="milestone-content">
            <div className="milestone-progress">
              <div className="progress-bar-container">
                <div
                  className="progress-bar-fill"
                  style={{
                    width: `${(current_streak / next_milestone.days) * 100}%`
                  }}
                />
              </div>
              <div className="progress-text">
                {current_streak} / {next_milestone.days} days
              </div>
            </div>
            <div className="milestone-reward">
              <span className="reward-icon">💰</span>
              <span className="reward-amount">
                ${(next_milestone.reward / 100).toFixed(2)} DB
              </span>
            </div>
          </div>
          <div className="milestone-footer">
            {next_milestone.days_remaining === 1 ? (
              <span className="days-remaining urgent">
                🚨 Just 1 more day!
              </span>
            ) : (
              <span className="days-remaining">
                {next_milestone.days_remaining} days to go
              </span>
            )}
          </div>
        </div>
      )}

      {!hasStreak && (
        <div className="streak-motivation">
          <p>Complete a task today to start your streak! 🚀</p>
        </div>
      )}

      {hasStreak && !hasNextMilestone && (
        <div className="streak-celebration">
          <p>🎉 You've reached all milestones! Keep the streak alive!</p>
        </div>
      )}
    </div>
  );
};

export default StreakTracker;
